/**
 * What a journey outside the photographer's own city costs (spec §12 · I9).
 *
 * > W obrębie miasta fotografa bezpłatnie. Poza miastem 5 zł za km (stawka
 * > edytowalna przez Admina).
 *
 * The key and the default live here — beside the seed that writes the setting —
 * for the reason `rental-terms.ts` and `shoot-plans.ts` do: `@repo/db` may not
 * import `@repo/core`. The arithmetic is in
 * `@repo/core/src/capacity/shoot-plan.ts`.
 */

/** Where the Admin's rate lives. A setting, because spec §12 says they edit it. */
export const TRAVEL_RATE_KEY = 'production.travel_rate_net_minor_per_km'

/** …and what applies until they do: 5 zł net a kilometre. */
export const DEFAULT_TRAVEL_RATE_NET_MINOR = 500
